const client = process.env.REACT_APP_ADSENSE_CLIENT?.trim() || 'ca-pub-8271899928033880';
const homeSlot = process.env.REACT_APP_ADSENSE_HOME_SLOT?.trim() || '';
const resultsSlot = process.env.REACT_APP_ADSENSE_RESULTS_SLOT?.trim() || '';

const isPublisherId = /^ca-pub-\d+$/.test(client);
const isSlotId = (slot: string) => /^\d+$/.test(slot);

export const adSenseConfig = {
  client,
  homeSlot,
  resultsSlot,
  enabled: isPublisherId,
  hasHomeSlot: isPublisherId && isSlotId(homeSlot),
  hasResultsSlot: isPublisherId && isSlotId(resultsSlot),
} as const;
